export default {
    jsonToDomSetter: {
        title: 'JSON選擇器',
        expression: '表達式',
        expressionTip: '請在下方選擇壹個節點',
        arrayInputKey: '輸入',
        confirm: '確定',
        cancel: '取消',
    }
}